// extracted by mini-css-extract-plugin
export default {"page":"wMPDiPzM79snEZZc2rd4","divider":"PWPGbavQraSkaWwcBC5M","grid":"FgScv5bgK3RePP3L2pXM","single":"DcEGnqK0XSL4j66fcgyA"};